module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box collapsed-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Histórico do paciente "), (_vm.showInfo) ? _c('a', {
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Paciente possui agendamentos ainda não realizados.",
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$emit('showModalNaoRealizados')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-info-circle"
  })]) : _vm._e()]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade Solicitante")]), _vm._v(" "), _c('select-unidade', {
    on: {
      "setUnidadeSelecionada": function (unidadeSelecionada) {
        _vm.setUnidadeSolicitante(unidadeSelecionada);
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade realizadora")]), _vm._v(" "), _c('select-unidade', {
    on: {
      "setUnidadeSelecionada": function (unidadeSelecionada) {
        _vm.setUnidadePrestadora(unidadeSelecionada);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Procedimento")]), _vm._v(" "), _c('select-procedimento', {
    on: {
      "setProcedimentoSelecionado": function (procedimentoSelecionado) {
        _vm.setProcedimentoSelecionado(procedimentoSelecionado);
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional solicitante")]), _vm._v(" "), _c('select-profissional', {
    attrs: {
      "tipo-profissional": "Solicitante"
    },
    on: {
      "setProfissionalSolicitanteSelecionado": function (profissional) {
        _vm.setProfissionalSolicitanteSelecionado(profissional);
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional realizador")]), _vm._v(" "), _c('select-profissional', {
    attrs: {
      "tipo-profissional": "Realizador"
    },
    on: {
      "setProfissionalRealizadorSelecionado": function (profissional) {
        _vm.setProfissionalRealizadorSelecionado(profissional);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional marcador")]), _vm._v(" "), _c('select-usuario', {
    attrs: {
      "nivel": "marcador"
    },
    on: {
      "setUsuarioSelecionado": function (usuario) {
        _vm.setUsuarioSelecionado(usuario);
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Situação da solicitação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacao),
      expression: "filtros.situacao"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todas")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.MARCADA
    }
  }, [_vm._v("Marcada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.EM_REGULACAO
    }
  }, [_vm._v("Em regulação")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.REGULADA
    }
  }, [_vm._v("Regulada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE
    }
  }, [_vm._v("Informação pendente")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL
    }
  }, [_vm._v("Informação adicional")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.NEGATIVADA
    }
  }, [_vm._v("Negativada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.CONFIRMADA
    }
  }, [_vm._v("Confirmada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.CANCELADA
    }
  }, [_vm._v("Cancelada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.FALTA
    }
  }, [_vm._v("Falta")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO.REALIZADA
    }
  }, [_vm._v("Realizada")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Data da solicitação ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.data_solicitacao),
      expression: "filtros.data_solicitacao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "",
      "id": ""
    },
    domProps: {
      "value": (_vm.filtros.data_solicitacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "data_solicitacao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Data de realização")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.data_realizacao),
      expression: "filtros.data_realizacao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "",
      "id": ""
    },
    domProps: {
      "value": (_vm.filtros.data_realizacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "data_realizacao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.getHistorico()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar")])])])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Histórico do sistema novo")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.historico.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_c('strong', {
      class: _vm._f("situacaoSolicitacaoColor")(item.solicitacao.situacao)
    }, [_vm._v("\n                            " + _vm._s(_vm._f("situacaoSolicitacao")(item.solicitacao.situacao)) + "\n                        ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.nome : item.contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.data_atendimento : item.contrato_subgrupo_atendimento.data_atendimento)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.profissional.nome : "SEM PROFISSIONAL"))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento.procedimento.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.solicitacao.created_at)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.contrato_procedimento.contrato.unidade.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.solicitacao.profissional.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.solicitacao.usuario.name))])])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.historico.from) + " até " + _vm._s(this.historico.to) + " de " + _vm._s(this.historico.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 7,
      "data": _vm.historico
    },
    on: {
      "pagination-change-page": _vm.getHistorico
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade Solicitante")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtrosAntigo.unidade_solicitante),
      expression: "filtrosAntigo.unidade_solicitante"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtrosAntigo.unidade_solicitante)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtrosAntigo, "unidade_solicitante", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade realizadora")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtrosAntigo.unidade_realizadora),
      expression: "filtrosAntigo.unidade_realizadora"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtrosAntigo.unidade_realizadora)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtrosAntigo, "unidade_realizadora", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Procedimento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtrosAntigo.procedimento),
      expression: "filtrosAntigo.procedimento"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtrosAntigo.procedimento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtrosAntigo, "procedimento", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional solicitante")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtrosAntigo.profissional_solicitante),
      expression: "filtrosAntigo.profissional_solicitante"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtrosAntigo.profissional_solicitante)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtrosAntigo, "profissional_solicitante", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional realizador")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtrosAntigo.profissional_realizador),
      expression: "filtrosAntigo.profissional_realizador"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtrosAntigo.profissional_realizador)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtrosAntigo, "profissional_realizador", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional marcador")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtrosAntigo.profissional_marcador),
      expression: "filtrosAntigo.profissional_marcador"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtrosAntigo.profissional_marcador)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtrosAntigo, "profissional_marcador", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Situação da solicitação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtrosAntigo.situacao),
      expression: "filtrosAntigo.situacao"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtrosAntigo, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Todas")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO_ANTIGA.EM_ANALISE
    }
  }, [_vm._v("Em análise")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO_ANTIGA.APROVADA
    }
  }, [_vm._v("Aprovada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO_ANTIGA.CONFIRMADA
    }
  }, [_vm._v("Confirmada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO_ANTIGA.NEGADA
    }
  }, [_vm._v("Negada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO_ANTIGA.EM_PERICIA
    }
  }, [_vm._v("Em perícia")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO_ANTIGA.CANCELADA
    }
  }, [_vm._v("Cancelada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO_ANTIGA.REALIZADA
    }
  }, [_vm._v("Confirmada")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO_ANTIGA.FALTA
    }
  }, [_vm._v("Falta")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO_ANTIGA.EM_SUPERVISAO
    }
  }, [_vm._v("Em supervisão")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO_ANTIGA.SUPERVISIONADO
    }
  }, [_vm._v("Supervisionado")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO_ANTIGA.EM_EXTRAPOLACAO
    }
  }, [_vm._v("Em extrapolação")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO_ANTIGA.TFD
    }
  }, [_vm._v("TFD")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO_SOLICITACAO_ANTIGA.FALTA_AUTOMATICA
    }
  }, [_vm._v("Falta automática")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Data da solicitação ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtrosAntigo.data_solicitacao),
      expression: "filtrosAntigo.data_solicitacao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtrosAntigo.data_solicitacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtrosAntigo, "data_solicitacao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Data de realização")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtrosAntigo.data_realizacao),
      expression: "filtrosAntigo.data_realizacao"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.filtrosAntigo.data_realizacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtrosAntigo, "data_realizacao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.getHistoricoAntigo()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar")])])])])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Histórico importado da base de dados anterior")]), _vm._v(" "), (this.hasPermission('paciente.read')) ? _c('router-link', {
    staticClass: "btn btn-sm btn-warning",
    staticStyle: {
      "margin": "0px 0px 5px 10px"
    },
    attrs: {
      "tag": "a",
      "to": "/integracao/pacientes"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Ir para o CADASTRO DE PACIENTES no módulo de integração com o sistema antigo ")]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.historicoAntigo.data), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_c('strong', {
      class: _vm._f("situacaoSolicitacaoAntigaColor")(item.situacao)
    }, [_vm._v("\n                            " + _vm._s(_vm._f("situacaoSolicitacaoAntiga")(item.situacao)) + "\n                        ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.unidade_realizadora))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_realizacao)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.profissional_realizador))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.procedimento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_solicitacao)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.unidade_solicitante))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.profissional_solicitante))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.profissional_marcador))])])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.historicoAntigo.from) + " até " + _vm._s(this.historicoAntigo.to) + " de " + _vm._s(this.historicoAntigo.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 7,
      "data": _vm.historicoAntigo
    },
    on: {
      "pagination-change-page": _vm.getHistoricoAntigo
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Situação")]), _vm._v(" "), _c('th', [_vm._v("Unidade realizadora")]), _vm._v(" "), _c('th', [_vm._v("Data da realização")]), _vm._v(" "), _c('th', [_vm._v("Prof. Realizador")]), _vm._v(" "), _c('th', [_vm._v("Procedimento")]), _vm._v(" "), _c('th', [_vm._v("Solicitado em")]), _vm._v(" "), _c('th', [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('th', [_vm._v("Prof. Solicitante")]), _vm._v(" "), _c('th', [_vm._v("Prof. Marcador")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Situação")]), _vm._v(" "), _c('th', [_vm._v("Unidade realizadora")]), _vm._v(" "), _c('th', [_vm._v("Data da realização")]), _vm._v(" "), _c('th', [_vm._v("Prof. Realizador")]), _vm._v(" "), _c('th', [_vm._v("Procedimento")]), _vm._v(" "), _c('th', [_vm._v("Solicitado em")]), _vm._v(" "), _c('th', [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('th', [_vm._v("Prof. Solicitante")]), _vm._v(" "), _c('th', [_vm._v("Prof. Marcador")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-209f6242"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atendimentos/solicitacao/historicos.vue
// module id = 813
// module chunks = 0